const source = 'kec';
const Version = '2016-03-04';
const Service = 'eip';
const keadService = 'kead';
const kecService = 'kec';
const KecPath = '/kecapi/';


export const CheckEipQuota = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'CheckEipQuota',
        Service,
        Version,
        source,
    }
};
export const DescribeKeadMinRate = {
    method: 'get',
    path: KecPath,
    params: {
        Action: 'DescribeKeadMinRate',
        Service:keadService,
        Version,
        source,
    }
};
export const DescribeKead = {
    method: 'post',
    path: KecPath,
    params: {
        Action: 'DescribeKead',
        Service:keadService,
        Version,
        source,
    }
};
//高防 白名单效验
export const ValidWhitelist = {
    path: KecPath,
    params: {
        Action: 'ValidWhitelist',
        Service:kecService,
        Version,
        source
    },
    method: 'get'
};